import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "35ea3ed3-6abe-4e18-8606-d434ac69150f",
    content: "Offers an excellent<br>envelopment experience",
    options: {},
  },
  {
    id: "e4d9664f-1d36-41bf-bfaf-bf90eff62cd1",
    content: "Offers a good perception<br>of source elevation",
    options: {},
  },
  {
    id: "cd12fe9a-9f22-437a-a2b3-a5f7107c9b6b",
    content: "Allows good localization regardless<br>of the listener's position ",
    options: {},
  },
  {
    id: "03e61560-c967-45aa-9ceb-0b10fb18a115",
    content: "Offers a good source localization<br>between the speakers ",
    options: {},
  },
  {
    id: "77a01100-45af-42f8-a7d4-5758e41aa4d1",
    content: "Works best with four speakers",
    options: {},
  },
  {
    id: "a887ef44-63b4-4fd2-b59d-43d6fec23053",
    content: "Provides very good depth coding",
    options: {},
  },
];

export const task: Task = {
  id: "4696bde4-3aad-429b-b871-2a5e90f24d21",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["03e61560-c967-45aa-9ceb-0b10fb18a115"],
};
